import script from "./SubstudyList.vue?vue&type=script&setup=true&lang=js"
export * from "./SubstudyList.vue?vue&type=script&setup=true&lang=js"

import "./SubstudyList.vue?vue&type=style&index=0&id=754d4bed&scoped=true&lang=css"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754d4bed"]])

export default __exports__